import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

const ActionHandler = () => {
  const [searchParams] = useSearchParams();
  const mode = searchParams.get("mode");
  const navigate = useNavigate();

  useEffect(() => {
    switch (mode) {
      case "resetPassword":
        navigate(`/reset-password?${searchParams.toString()}`);
        break;
      case "verifyEmail":
        navigate(`/verify-email?${searchParams.toString()}`);
        break;
      case "signIn":
        navigate(`/login?${searchParams.toString()}`);
        break;
      default:
        navigate("/not-found");
        break;
    }
  }, [mode, navigate, searchParams]);

  return <p>Redirecting...</p>;
};

export default ActionHandler;
